<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { DialogTitle, type DialogTitleProps } from 'reka-ui';
import { cn } from '@/lib/utils';
const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>();
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});
</script>

<template>
  <DialogTitle
    v-bind="forwarded"
    :class="cn('pr-6 text-lg font-semibold leading-tight tracking-tight', props.class)"
    ><slot
  /></DialogTitle>
</template>
